import http from '../config/http';
import routes from '../config/api_routes';

export const enviarMensagem = (mensagem) => {
    return http().post(routes.faleConosco.enviar, mensagem);
};